export default __webpack_public_path__ + "static/media/16.a746a349.webp";